import React from 'react'
import { fadeUp } from 'Utils/animations'
import { Checkbox } from 'Components/Checkbox/Checkbox'
import Touchable from 'Components/touchables/Touchable'
import { PATHS } from 'Utils/routing'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import classNames from 'classnames'
import styles from './ContactForm.module.scss'

const LABEL_DIVIDER = '|||' // Как в файлах translation

export type ContactCheckboxProps = {
  isChecked: boolean
  onCheck: (value: boolean) => void
  index: number
  className?: string
}

export const ContactCheckbox = (props: ContactCheckboxProps) => {
  const { isChecked, onCheck, index, className } = props

  const [t] = useTranslation()

  const [main, link] = t('order.section.checkbox').split(LABEL_DIVIDER)

  const label = (
    <>
      {main}
      <Touchable className={styles.link} link={PATHS.policy}>
        {link}
      </Touchable>
    </>
  )

  return (
    <div className={classNames([styles.checkbox, className])} {...fadeUp({ index })}>
      <Checkbox label={label} value={isChecked} onChange={onCheck} />
    </div>
  )
}
